<template>
  <div class="home overflow-hidden">
    <HomePageLoggedInHero />
    <ThreeCardBlueLayout />
    <ThreeCardYellowLayout />
    <FiveCardLayout />
    <SunHeroCallout />
  </div>
</template>

<script>
import SunHeroCallout from "../components/elements/SunHeroCallout.vue";
import HomePageLoggedInHero from "../components/elements/HomePageLoggedInHero.vue";
import ThreeCardBlueLayout from "../components/elements/ThreeCardBlueLayout.vue";
import ThreeCardYellowLayout from "../components/elements/ThreeCardYellowLayout.vue";
import FiveCardLayout from "../components/elements/FiveCardLayout.vue";
export default {
  name: "HomeLoggedIn",
  metaInfo: {
    title: "HomeLoggedIn",
  },
  components: {
    SunHeroCallout,
    HomePageLoggedInHero,
    ThreeCardBlueLayout,
    ThreeCardYellowLayout,
    FiveCardLayout,
  },
};
</script>
<style scoped lang="less">
@import (reference) "~@/assets/css/variables.less";

// .jotform-form {
//   margin-top: .clampedW(7, @md-bp, @large-bp) [ @result];
//   margin-bottom: .clampedW(4, @md-bp, @large-bp) [ @result];
//   flex: 0 1 .clampedWrem(50, @md-bp, @large-bp) [ @result];
//   .form-textbox {
//     -webkiit-appearance: none;
//     border: .clampedW(0.3, @md-bp, @large-bp) [ @result] solid #f58220;
//     border-radius: 0;
//     margin: 0;
//     background-color: #fff;
//     //padding:.clampedW(1, @md-bp, @large-bp) [ @result] .clampedW(1.5, @md-bp, @large-bp) [ @result];
//     padding: 1rem 1.5rem;
//     font-size: .clampedWrem(3, @md-bp, @large-bp) [ @result];
//   }
//   .button {
//     display: inline-flex;
//     background-color: #f58220;
//     padding: .clampedWrem(3, @md-bp, @large-bp) [ @result]
//       .clampedWrem(4.8, @md-bp, @large-bp) [ @result];
//     margin: 0;
//     font-size: .clampedWrem(2.4, @md-bp, @large-bp) [ @result];
//     color: white;
//     width: 100%;
//     align-items: center;
//     justify-content: center;
//     text-decoration: none;
//     border: none;
//     cursor: pointer;
//     font-weight: 700;
//     text-align: center;
//   }
// }
// section.home-hero {
//   /*background: url('~@/assets/images/global/background-main.jpg') no-repeat center center;*/
//   background-size: 100% 100%;
//   padding: 0;
//   @media screen and (max-width: ~"@{mq-md-bp}em") {
//   }
// }
</style>
